import ScrollReveal from 'scrollreveal';

window.sr = ScrollReveal({
  duration: 1000,
  mobile: false,
});

// Collect all global elements to reveal
let globalReveals = document.querySelectorAll('[scroll-reveal]');
if (globalReveals.length) {
  sr.reveal(globalReveals);
}

// Homepage Reveals
if (document.querySelectorAll('.Homepage')) {
  // Hero Image
  let homepageFoldImage = document.querySelectorAll('[scroll-reveal="hero:image"]');
  let blockFrameDelay = homepageFoldImage.length ? 1500 : 500;
  let heroDuration = homepageFoldImage.length ? 1000 : 1500;

  if (homepageFoldImage.length) {
    sr.reveal(homepageFoldImage, {
      origin: 'right',
      scale: 1,
      delay: 1000,
      duration: 750,
    });
  }

  // Hero
  let homepageHero = document.querySelectorAll('[scroll-reveal="hero"]');
  if (homepageHero.length) {
    sr.reveal(homepageHero, {
      distance: '0',
      scale: 1,
      duration: heroDuration,
    });
  }

  // Info Block below the Hero
  let homepageFoldBlock = document.querySelectorAll('[scroll-reveal="hero:block"]');
  if (homepageFoldBlock.length) {
    sr.reveal(homepageFoldBlock, {
      origin: 'bottom',
      scale: 1,
      delay: blockFrameDelay,
      duration: 500,
    });
  }

  // Hero Text 1
  let homepageFoldText1 = document.querySelectorAll('[scroll-reveal="hero:text1"]');
  if (homepageFoldText1.length) {
    sr.reveal(homepageFoldText1, {
      distance: '5px',
      scale: 0.97,
      duartion: 200,
      delay: blockFrameDelay + 500,
    }, 400);
  }

  // Hero Text 2
  let homepageFoldText2 = document.querySelectorAll('[scroll-reveal="hero:text2"]');
  if (homepageFoldText2.length) {
    sr.reveal(homepageFoldText2, {
      distance: '5px',
      scale: 0.85,
      duartion: 300,
      delay: blockFrameDelay + 1300,
    }, 400);
  }

  // Hero CTA
  let homepageFoldButton = document.querySelectorAll('[scroll-reveal="hero:button"]');
  if (homepageFoldButton.length) {
    sr.reveal(homepageFoldButton, {
      distance: '5px',
      scale: 1,
      duartion: 200,
      delay: blockFrameDelay + 2300,
    });
  }

  // Homepage What We Do sections
  let whatWeDo = document.querySelectorAll('.WhatWeDoItem');
  if (whatWeDo.length) {
    sr.reveal(whatWeDo, 500);
  }

  // Hompage feature articles
  let homepageResourceListing = document.querySelectorAll('.Homepage .ResouceListing-item');
  if (homepageResourceListing.length) {
    sr.reveal(homepageResourceListing, {}, 150);
  }
}